(function bulkDiscountSidebar() {
  'use strict';

  var BODY_CLASS = 'bulk-discount-sidebar-show';
  var SIDEBAR_ID = 'bulk-discount-sidebar';
  var CLOSE_ATTR = 'data-close-bulk-discount-sidebar';
  var OPEN_ATTR = 'data-open-bulk-discount-sidebar';
  var SUBMIT_ATTR = 'data-bulk-sidebar-submit';
  var RESET_ATTR = 'data-bulk-sidebar-reset';
  var FORM_BODY_ATTR = 'data-sidebar-form-body';
  var SUCCESS_ATTR = 'data-sidebar-success-panel';
  var VARIANT_SELECT_ATTR = 'data-sidebar-variant-select';
  var VARIANT_TITLE_ATTR = 'data-sidebar-variant-title';
  var SUBMISSION_SOURCE_ATTR = 'data-sidebar-submission-source';
  var FORM_VARIANT_ATTR = 'data-sidebar-form-variant';
  var DYNAMIC_TITLE_ATTR = 'data-sidebar-dynamic-title';

  var EXPANDABLE_TOGGLE = '.bulk-discount-expandable-toggle';
  var EXPANDABLE_CONTENT = '.bulk-discount-expandable-content';

  var ERROR_CLASS = 'bulk-discount-form-field--error';
  var ERROR_MESSAGE_CLASS = 'bulk-discount-field-error';

  var sidebarEl = null;
  var lastTriggerEl = null;
  var focusTrapHandler = null;

  var VARIANT_CONFIG = {
    priced_offer: {
      titleKey: 'bulk_discount.sidebar.title_priced',
      source: 'pdp_bulk_discount_discounted',
      formVariant: 'priced_offer'
    },
    trade_inquiry: {
      titleKey: 'bulk_discount.sidebar.title_inquiry',
      source: 'pdp_bulk_discount_inquiry',
      formVariant: 'trade_inquiry'
    }
  };

  function getSidebar() {
    if (!sidebarEl) {
      sidebarEl = document.getElementById(SIDEBAR_ID);
    }
    return sidebarEl;
  }

  function isOpen() {
    return document.body.classList.contains(BODY_CLASS);
  }

  function getLocaleString(key) {
    var el = document.querySelector('[data-locale-' + key + ']');
    return el ? el.textContent : key;
  }

  function getTriggerVariant(triggerEl) {
    var wrapper = triggerEl.closest('[data-bulk-discount-variant]');
    return wrapper ? wrapper.getAttribute('data-bulk-discount-variant') : 'priced_offer';
  }

  function syncVariantDropdown(sidebar) {
    var variantSelect = sidebar.querySelector('[' + VARIANT_SELECT_ATTR + ']');
    if (!variantSelect) return;

    var pdpSelector = document.querySelector('select[name="id"]');
    if (!pdpSelector) return;

    var selectedOption = pdpSelector.options[pdpSelector.selectedIndex];
    if (!selectedOption) return;

    var pdpTitle = selectedOption.getAttribute('data-variant-title') || selectedOption.textContent.trim().split(' - ')[0].trim();

    for (var i = 0; i < variantSelect.options.length; i++) {
      var optTitle = variantSelect.options[i].textContent.trim().split(' - ')[0].trim();
      if (optTitle === pdpTitle && !variantSelect.options[i].disabled) {
        variantSelect.selectedIndex = i;
        break;
      }
    }
  }

  function updateHiddenFields(sidebar, config) {
    var sourceField = sidebar.querySelector('[' + SUBMISSION_SOURCE_ATTR + ']');
    if (sourceField) sourceField.value = config.source;

    var variantField = sidebar.querySelector('[' + FORM_VARIANT_ATTR + ']');
    if (variantField) variantField.value = config.formVariant;

    var form = sidebar.querySelector('form');
    if (form) {
      form.setAttribute('data-bulk-quote-source', config.source);
      form.setAttribute('data-bulk-quote-variant', config.formVariant);
    }
  }

  function updateDynamicTitle(sidebar, config) {
    var titleEl = sidebar.querySelector('[' + DYNAMIC_TITLE_ATTR + ']');
    if (titleEl) {
      var localeAttr = config.formVariant === 'trade_inquiry'
        ? 'data-locale-sidebar-title-inquiry'
        : 'data-locale-sidebar-title-priced';
      var localeEl = sidebar.querySelector('[' + localeAttr + ']');
      if (localeEl) {
        titleEl.textContent = localeEl.textContent;
      }
    }
  }

  function updateDynamicSubmit(sidebar, config) {
    var submitTextEl = sidebar.querySelector('[' + SUBMIT_ATTR + '] [data-submit-text]');
    if (!submitTextEl) return;

    var localeAttr = config.formVariant === 'trade_inquiry'
      ? 'data-locale-submit-inquiry'
      : 'data-locale-submit-priced';
    var localeEl = sidebar.querySelector('[' + localeAttr + ']');
    if (localeEl) {
      submitTextEl.textContent = localeEl.textContent;
      submitTextEl.setAttribute('data-default-text', localeEl.textContent);
    }

    var submitBtn = sidebar.querySelector('[' + SUBMIT_ATTR + ']');
    if (submitBtn) {
      submitBtn.setAttribute('aria-label', submitTextEl.textContent);
    }
  }

  function updateVariantTitleHidden(sidebar) {
    var variantSelect = sidebar.querySelector('[' + VARIANT_SELECT_ATTR + ']');
    var variantTitleField = sidebar.querySelector('[' + VARIANT_TITLE_ATTR + ']');
    if (variantSelect && variantTitleField) {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      variantTitleField.value = opt ? opt.value : '';
    }
  }

  function open(triggerEl) {
    var sidebar = getSidebar();
    if (!sidebar || isOpen()) return;

    lastTriggerEl = triggerEl || null;

    resetFormState(sidebar);

    var variant = getTriggerVariant(triggerEl);
    var config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.priced_offer;

    updateHiddenFields(sidebar, config);
    updateDynamicTitle(sidebar, config);
    updateDynamicSubmit(sidebar, config);
    syncVariantDropdown(sidebar);
    collapseExpandable(sidebar);

    document.body.classList.add(BODY_CLASS);
    sidebar.setAttribute('aria-hidden', 'false');

    if (triggerEl) {
      triggerEl.setAttribute('aria-expanded', 'true');
    }

    var form = sidebar.querySelector('form[data-bulk-quote-form]');
    if (form && form.dataset.bulkQuoteViewed !== 'true') {
      form.dataset.bulkQuoteViewed = 'true';
      document.dispatchEvent(new CustomEvent('bulk_quote_view_sidebar', {
        bubbles: true,
        detail: { form: form }
      }));
    }

    requestAnimationFrame(function () {
      var firstInput = sidebar.querySelector('input:not([type="hidden"]):not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"])');
      if (firstInput) firstInput.focus();
    });

    focusTrapHandler = createFocusTrap(sidebar);
    document.addEventListener('keydown', focusTrapHandler);
  }

  function close() {
    var sidebar = getSidebar();
    if (!sidebar || !isOpen()) return;

    document.body.classList.remove(BODY_CLASS);
    sidebar.setAttribute('aria-hidden', 'true');

    if (lastTriggerEl) {
      lastTriggerEl.setAttribute('aria-expanded', 'false');
      lastTriggerEl.focus();
      lastTriggerEl = null;
    }

    if (focusTrapHandler) {
      document.removeEventListener('keydown', focusTrapHandler);
      focusTrapHandler = null;
    }
  }

  function createFocusTrap(element) {
    return function (e) {
      if (e.key === 'Escape') {
        close();
        return;
      }

      if (e.key !== 'Tab') return;

      var focusable = element.querySelectorAll(
        'input:not([type="hidden"]):not([tabindex="-1"]):not([aria-hidden="true"]):not(:disabled), ' +
        'select:not([tabindex="-1"]):not([aria-hidden="true"]):not(:disabled), ' +
        'textarea:not([tabindex="-1"]):not([aria-hidden="true"]):not(:disabled), ' +
        'button:not(:disabled), [tabindex]:not([tabindex="-1"]):not([aria-hidden="true"])'
      );

      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
  }

  function collapseExpandable(sidebar) {
    var toggle = sidebar.querySelector(EXPANDABLE_TOGGLE);
    var content = sidebar.querySelector(EXPANDABLE_CONTENT);
    if (!toggle || !content) return;

    toggle.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = '0';
    content.style.overflow = 'hidden';

    var fields = content.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      fields[i].setAttribute('tabindex', '-1');
      fields[i].setAttribute('aria-hidden', 'true');
    }
  }

  function toggleExpandable(sidebar) {
    var toggle = sidebar.querySelector(EXPANDABLE_TOGGLE);
    var content = sidebar.querySelector(EXPANDABLE_CONTENT);
    if (!toggle || !content) return;

    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    var newState = !isExpanded;

    toggle.setAttribute('aria-expanded', String(newState));
    content.setAttribute('aria-hidden', String(!newState));

    var fields = content.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (newState) {
        fields[i].removeAttribute('tabindex');
        fields[i].removeAttribute('aria-hidden');
      } else {
        fields[i].setAttribute('tabindex', '-1');
        fields[i].setAttribute('aria-hidden', 'true');
      }
    }

    if (newState) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.overflow = 'visible';
    } else {
      content.style.maxHeight = '0';
      content.style.overflow = 'hidden';
    }
  }

  function clearFieldErrors(sidebar) {
    var errors = sidebar.querySelectorAll('.' + ERROR_MESSAGE_CLASS);
    for (var i = 0; i < errors.length; i++) {
      errors[i].remove();
    }

    var invalidFields = sidebar.querySelectorAll('.' + ERROR_CLASS);
    for (var j = 0; j < invalidFields.length; j++) {
      invalidFields[j].classList.remove(ERROR_CLASS);
      var input = invalidFields[j].querySelector('input, select, textarea');
      if (input) {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      }
    }
  }

  function showFieldError(field, message) {
    var wrapper = field.closest('.bulk-discount-form-field');
    if (!wrapper) return;

    wrapper.classList.add(ERROR_CLASS);
    field.setAttribute('aria-invalid', 'true');

    var errorId = field.id + '-error';
    field.setAttribute('aria-describedby', errorId);

    var existing = wrapper.querySelector('.' + ERROR_MESSAGE_CLASS);
    if (existing) existing.remove();

    var errorEl = document.createElement('span');
    errorEl.className = ERROR_MESSAGE_CLASS;
    errorEl.id = errorId;
    errorEl.setAttribute('role', 'alert');
    errorEl.textContent = message;
    wrapper.appendChild(errorEl);
  }

  function validateField(field) {
    if (!field.required) return true;

    var value = (field.value || '').trim();
    if (!value) {
      showFieldError(field, getRequiredMessage(field));
      return false;
    }

    if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      showFieldError(field, 'Please enter a valid email address');
      return false;
    }

    if (field.pattern) {
      var re = new RegExp('^' + field.pattern + '$');
      if (!re.test(value)) {
        showFieldError(field, 'Please match the requested format');
        return false;
      }
    }

    return true;
  }

  function getRequiredMessage(field) {
    var label = field.closest('.bulk-discount-form-field');
    if (label) {
      var labelEl = label.querySelector('.bulk-discount-form-label');
      if (labelEl) {
        var text = labelEl.textContent.replace('*', '').trim();
        return 'Please enter ' + text.toLowerCase();
      }
    }
    return 'This field is required';
  }

  function validateForm(form) {
    clearFieldErrors(form.closest('[data-bulk-discount-sidebar]'));

    var fields = form.querySelectorAll('input[required], textarea[required], select[required]');
    var firstInvalid = null;
    var isValid = true;

    for (var i = 0; i < fields.length; i++) {
      if (!validateField(fields[i])) {
        isValid = false;
        if (!firstInvalid) firstInvalid = fields[i];
      }
    }

    if (firstInvalid) {
      firstInvalid.focus();
    }

    return isValid;
  }

  function setLoading(form, isLoading) {
    var submitBtn = form.querySelector('[' + SUBMIT_ATTR + ']');
    if (!submitBtn) return;

    var textEl = submitBtn.querySelector('[data-submit-text]');
    var spinnerEl = submitBtn.querySelector('[data-submit-spinner]');

    submitBtn.disabled = isLoading;

    if (isLoading) {
      submitBtn.classList.add('loading');
      if (textEl) textEl.textContent = 'Sending...';
      if (spinnerEl) spinnerEl.removeAttribute('aria-hidden');
    } else {
      submitBtn.classList.remove('loading');
      if (textEl) textEl.textContent = getSubmitLabelText();
      if (spinnerEl) spinnerEl.setAttribute('aria-hidden', 'true');
    }

    var allFields = form.querySelectorAll('input, select, textarea, button');
    for (var i = 0; i < allFields.length; i++) {
      if (allFields[i] !== submitBtn) {
        if (isLoading) {
          allFields[i].setAttribute('aria-disabled', 'true');
        } else {
          allFields[i].removeAttribute('aria-disabled');
        }
      }
    }
  }

  function getSubmitLabelText() {
    var sidebar = getSidebar();
    if (!sidebar) return 'Submit';
    var btn = sidebar.querySelector('[' + SUBMIT_ATTR + '] [data-submit-text]');
    return btn ? btn.getAttribute('data-default-text') || btn.textContent : 'Submit';
  }

  function showServerError(form, message) {
    var existing = form.querySelector('.bulk-discount-server-error');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.className = 'bulk-discount-server-error';
    banner.setAttribute('role', 'alert');
    banner.innerHTML = '<p>' + (message || 'Something went wrong. Please try again or contact us directly.') + '</p>' +
      '<button type="button" class="bulk-discount-server-retry" data-bulk-sidebar-retry>Try again</button>';
    form.insertBefore(banner, form.firstChild);
  }

  function showSuccess(sidebar) {
    var formBody = sidebar.querySelector('[' + FORM_BODY_ATTR + ']');
    var successPanel = sidebar.querySelector('[' + SUCCESS_ATTR + ']');

    if (formBody) formBody.style.display = 'none';
    if (successPanel) successPanel.style.display = '';

    document.dispatchEvent(new CustomEvent('contactFormAjaxSuccess', {
      bubbles: true,
      detail: { form: sidebar.querySelector('form') }
    }));
  }

  function resetFormState(sidebar) {
    var formBody = sidebar.querySelector('[' + FORM_BODY_ATTR + ']');
    var successPanel = sidebar.querySelector('[' + SUCCESS_ATTR + ']');

    if (formBody) formBody.style.display = '';
    if (successPanel) successPanel.style.display = 'none';

    var form = sidebar.querySelector('form');
    if (form) {
      clearFieldErrors(sidebar);

      var serverError = form.querySelector('.bulk-discount-server-error');
      if (serverError) serverError.remove();

      setLoading(form, false);
    }
  }

  function submitForm(form) {
    var sidebar = form.closest('[data-bulk-discount-sidebar]');

    updateVariantTitleHidden(sidebar);

    if (!validateForm(form)) return;

    setLoading(form, true);

    var formData = new FormData(form);
    var actionUrl = form.getAttribute('action') || window.location.pathname;

    fetch(actionUrl, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(function (htmlText) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlText, 'text/html');

      var successMessage = doc.querySelector('.alertBox--success');
      if (successMessage) {
        showSuccess(sidebar);
        return;
      }

      var errors = doc.querySelectorAll('.bulk-discount-form-errors li');
      if (errors.length) {
        setLoading(form, false);
        for (var i = 0; i < errors.length; i++) {
          var li = errors[i];
          var text = li.textContent.trim();
          var fieldName = text.split(' - ')[0].trim().toLowerCase();
          var field = findFieldByLabel(form, fieldName);
          if (field) {
            showFieldError(field, text.split(' - ')[1] || text);
          }
        }
        var firstError = form.querySelector('.' + ERROR_CLASS + ' input, .' + ERROR_CLASS + ' textarea');
        if (firstError) firstError.focus();
        return;
      }

      showSuccess(sidebar);
    })
    .catch(function () {
      setLoading(form, false);
      showServerError(form, 'Something went wrong. Please try again or contact us directly.');
    });
  }

  function findFieldByLabel(form, labelFragment) {
    var labels = {
      'email': 'email',
      'name': 'name',
      'quantity': 'quantity',
      'order details': 'message',
      'message': 'message'
    };

    var nameHint = labels[labelFragment] || labelFragment;
    var field = form.querySelector('[name*="' + nameHint + '" i]');
    if (field) return field;

    return form.querySelector('input[required], textarea[required]');
  }

  function handleBlurValidation(e) {
    var field = e.target;
    if (!field.required) return;
    if (!field.closest('[data-bulk-discount-sidebar]')) return;

    var wrapper = field.closest('.bulk-discount-form-field');
    if (!wrapper) return;

    if (!field.value.trim() && wrapper.classList.contains(ERROR_CLASS)) return;

    clearFieldErrors(field.closest('[data-bulk-discount-sidebar]'));
    validateField(field);
  }

  function init() {
    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[' + OPEN_ATTR + ']');
      if (openTrigger) {
        e.preventDefault();
        open(openTrigger);
        return;
      }

      if (e.target.closest('[' + CLOSE_ATTR + ']')) {
        close();
        return;
      }

      if (isOpen() && e.target.classList.contains('background-overlay')) {
        close();
        return;
      }

      var expandToggle = e.target.closest(EXPANDABLE_TOGGLE);
      if (expandToggle) {
        var sidebar = getSidebar();
        if (sidebar) toggleExpandable(sidebar);
        return;
      }

      if (e.target.closest('[' + RESET_ATTR + ']')) {
        var sb = getSidebar();
        if (sb) {
          var form = sb.querySelector('form');
          if (form) form.reset();
          resetFormState(sb);
        }
        return;
      }

      if (e.target.closest('[data-bulk-sidebar-retry]')) {
        var sb2 = getSidebar();
        if (sb2) {
          var serverError = sb2.querySelector('.bulk-discount-server-error');
          if (serverError) serverError.remove();
        }
        return;
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector('[data-bulk-discount-sidebar]')) {
        if (!form || !form.closest('[data-bulk-discount-sidebar]')) return;
      }
      if (!form.closest('[data-bulk-discount-sidebar]')) return;

      e.preventDefault();
      submitForm(form);
    });

    document.addEventListener('focusout', handleBlurValidation);

    var sidebar = getSidebar();
    if (sidebar && window.location.search.indexOf('contact_posted=true') > -1) {
      var triggerEl = document.querySelector('[' + OPEN_ATTR + ']');
      if (triggerEl) {
        open(triggerEl);
      }
    }

    var submitTextEl = sidebar ? sidebar.querySelector('[' + SUBMIT_ATTR + '] [data-submit-text]') : null;
    if (submitTextEl) {
      submitTextEl.setAttribute('data-default-text', submitTextEl.textContent);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
